import React from 'react'

const IconRecentlyUsed = ({ style = {}, ...props }) => {
  return (
    <svg
      width="26px"
      height="26px"
      viewBox="0 0 26 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
      {...props}>
      <title>icon-recent-small</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="icon-recent-small" fill="#77CA34" fillRule="nonzero">
          <circle id="Oval" fillOpacity="0.07" cx="13" cy="13" r="13" />
          <path
            d="M13,-1.13692594e-05 C20.18,-1.13692594e-05 26,5.82 26,13 C26,20.18 20.18,26 13,26 C5.82,26 0,20.18 0,13 C0,12.4477153 0.44771525,12 1,12 C1.55228475,12 2,12.4477153 2,13 C2,19.075 6.925,24 13,24 C19.075,24 24,19.075 24,13 C24,6.925 19.075,2 13,2 C10.4349751,1.9969784 7.94998773,2.89289013 5.977,4.532 L8.354,7.172 C8.45678199,7.28608873 8.48640148,7.44840366 8.43054042,7.59144182 C8.37467936,7.73447999 8.24289757,7.83376247 8.09,7.848 L1.885,8.408 C1.63001126,8.43120401 1.37901468,8.33278138 1.20776401,8.14243724 C1.03651333,7.95209311 0.965071314,7.69212708 1.015,7.441 L2.218,1.327 C2.24779251,1.17619594 2.36019894,1.05514969 2.5083883,1.01429177 C2.65657766,0.973433844 2.81513429,1.01977171 2.918,1.134 L4.637,3.044 C6.97809184,1.07420479 9.94045955,-0.00405029344 13,-1.13692594e-05 Z M14,7 C13.4477153,7 13,7.44771525 13,8 L13,13 L9,13 C8.44771525,13 8,13.4477153 8,14 C8,14.5522847 8.44771525,15 9,15 L14,15 C14.5522847,15 15,14.5522847 15,14 L15,8 C15,7.44771525 14.5522847,7 14,7 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  )
}

export default IconRecentlyUsed
